<template>
  <!-- tab切换 -->
  <div
    class='quote-graph-controller'
    @click.stop='_tapTab'
  >
    <span
      v-for='(item, index) in tabList'
      :data='item.key'
      :key='item.key'
      :class='["quote-graph-tab", {"quote-graph-tab-active": item.key === customKey}, {"quote-graph-tab-fold": item.fold}]'
      :title="item.text"
    >{{item.text}}</span>
    <div
      v-if='hasMenu'
      class='quote-graph-menu'
    >
      <div
        :class='["quote-graph-menu-span", {"quote-graph-tab-active": minuteActive}]'
        @click.stop='tapMenu'
      >{{minuteText}}<i :class='[showMenu ? "quote-graph-triangle-anti" : "quote-graph-triangle"]'></i></div>
      <div
        v-show='showMenu'
        class='quote-graph-menu-container'
      >
        <div
          v-for='(item, index) in foldList'
          :data='item.key'
          :key='item.key'
          :class='["quote-graph-tab", {"quote-graph-tab-active": item.key === period}]'
        >{{item.foldText}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Util, { watch } from '../../util/index.js';
export default {
  name: 'TabController',
  data() {
    return {
      showMenu: false,
    }
  },
  props: {
    tabList: {
      type: Array,
      default: () => ([]),
    },
    period: {
      type: [String, Number],
    },
    tapTab: {
      type: Function,
      default: () => { },
    },
    customKey: {
      type: [String, Number]
    }
  },
  computed: {
    foldList() {
      return this.tabList.filter(a => a.fold);
    },
    hasMenu() {
      return this.foldList.length !== 0;
    },
    minuteActive() {
      return this.tabList.find(a => a.key === this.period && a.fold === true) !== undefined;
    },
    minuteText() {
      const item = this.tabList.find(a => a.key === this.period && a.fold === true);
      if (item) {
        return item.foldText;
      }
      return '分钟';
    }
  },
  methods: {
    tapMenu(showMenu) {
      if (Util.isBoolean(showMenu)) {
        this.showMenu = showMenu;
      } else {
        this.showMenu = !this.showMenu;
      }
    },
    _tapTab(e) {
      const key = e.target.getAttribute('data');
      if (key) {
        // Revised on 2022-03-05
        const tab = this.tabList.find(a => a.key == key);
        // Revised on 2022-03-05
        if (tab) {
          this.tapMenu(false);
          this.tapTab(tab.key);
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-graph-controller .quote-graph-tab {
  margin-right: 4px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.quote-graph-controller .quote-graph-tab:hover {
  color: #4eabf9;
}
.quote-graph-controller .quote-graph-tab-active {
  font-weight: bold;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
